module.exports = __webpack_public_path__ + "img/skinwash_step2.9f6654f4.jpg";